(function () {
  'use strict';

  // 

  const accordeon = document.querySelector('.accordeon');
  if (accordeon) {
    const accordeionTabs = accordeon.querySelector('.accordeon__tabs');
    const firstActive = document.getElementById('description');
    window.addEventListener('load', () => {
      accordeionTabs.style.height = firstActive.scrollHeight + 'px';
    });
    accordeon.addEventListener('click', event => {
      const btnTarget = event.target.closest('.accordeon__btn');
      if (!btnTarget) return; // Ignore clicks on elements without the .accordeon__btn class

      const target = btnTarget.dataset.target;
      const textElement = document.getElementById(target);
      if (!textElement) return; // Ignore clicks on elements without valid targets

      // Toggle active class on text element
      textElement.classList.toggle('active');

      // Toggle active class on button element
      accordeon.querySelectorAll('.accordeon__btn').forEach(item => {
        item.classList.toggle('active', item === btnTarget);
      });

      // Close inactive text elements
      accordeon.querySelectorAll('.accordeon__text').forEach(item => {
        if (item !== textElement) {
          item.classList.remove('active');
        } else {
          accordeionTabs.style.height = item.scrollHeight + 'px';
        }
      });
    });
  }

})();
